<template>
  <div class="outerWrapper">
    <div class="cardBox shadowed" v-if="offer.partner">
      <div style="min-height: 265px">
        <img class="full-width cardImage" :src="offer.cardImage || '/img/partner_offer_card_placeholder.png'" @click="handleResourceToggle"/>
      </div>
      <div class="p-2 pb-3">
        <div class="cardPartnerLogoParent">
          <div class="cardPartnerLogoWrapper shadowed">
            <div class="cardPartnerLogo" :style="{'background-image': `url('${offer.partner.logoImage || '/img/partner_logo_placeholder.png'}')`}"/>
          </div>
        </div>
        <div class="centered pb-2">
          <OfferTag :tag="tag" type="CATEGORY" v-for="tag in offer.tags.filter(t=>t.id.startsWith('category::'))" :key="tag.id"/>
        </div>
        <h1 class="cardTitle pb-2">
          {{ offer.name }}
        </h1>
        <div class="p-1 pb-2 cardDescriptionWrapper">
          <span class="centered w-full cardDescription">
            {{ offer.description }}
          </span>
        </div>
        <div class="pt-2 pr-1 pl-1">
          <button class="cardViewButton" @click="handleResourceToggle">
            VIEW RESOURCE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PartnerOffer } from '@/features/partnerOffers/model';
import { InteractionType } from '@/features/analytics/api';
import { logInteraction } from './api';
import OfferTag from './OfferTag.vue';
import { displayModalOffer } from './state';

const props = defineProps<{
  offer: PartnerOffer,
  context: string,
}>();

const handleResourceToggle = async () => {
  displayModalOffer(props.context, props.offer);
  logInteraction(props.context, props.offer, InteractionType.CLICK, "card");
};

</script>

<style lang="scss">
@import "../../assets/variables.scss";

.outerWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cardBox {
  max-width: 475px;
  border: 1px solid rgb(180,210,180);
}

.cardImage {
  cursor: pointer;
}

.cardPartnerLogoParent {
  padding: 1rem;
  height: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  position: relative;
}

.cardPartnerLogoWrapper {
  padding: 0.5rem;
  background-color: white;

  position: absolute;
  top: -4.5rem;
}

.cardPartnerLogo {
  width: 10rem;
  height: 5rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.cardTitle {
  text-align: center;
  font-size: inherit;
}
.cardDescriptionWrapper {
  display: flex;
  align-items: center;
  min-height: 5em;
}

.cardDescription {
  color: #707070;
  font-size: 0.96rem;
}

.cardViewButton {
  width: 100%;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;

  color: white;
  font-weight: 700;
  font-size: 0.875rem;
  font-family: inherit;
  line-height: inherit;

  background-color: $primary;
  border-style: none;
  border-radius: 0.3rem;

  cursor: pointer;
}

.centered {
  text-align: center;
}
</style>
